import http from "./httpService";
import { getApiUrl } from "../config";

const apiEndpoint = getApiUrl() + "/usuarios";
const Endpoints = {
    requestPasswordToken: apiEndpoint + "/requestPasswordToken",
    requestPasswordChange: apiEndpoint + "/requestPasswordChange"
}

function userUrl(id) {
    return `${apiEndpoint}/${id}`;
}

async function getUsers(): Promise<Usuario[]> {
    let resp = await http.get<Usuario[]>(apiEndpoint);
    return resp.data;
}

function getUser(userId) {
    return http.get(userUrl(userId));
}



async function requestPasswordToken({ email }: {
    email: string;

}) {

    const response = await http.post<any>(Endpoints.requestPasswordToken, { email });
    return response.data;

};

async function requestPasswordChange({ password, token, email }: {
    password: string;
    token: string;
    email: string;

}) {
    const response = await http.post<any>(Endpoints.requestPasswordChange, { password, token, email });
    return response.data;

};


function saveUser(user) {
    if (user.id) {
        const body = { ...user };
        delete body.id;
        return http.put(userUrl(user.id), body);
    }
    return http.post(apiEndpoint, user);
}

function deleteUser(userId) {
    return http.delete(userUrl(userId));
}

const exportObject = {
    getUsers,
    getUser,
    saveUser,
    deleteUser,
    requestPasswordToken,
    requestPasswordChange
};

export default exportObject;